import classNames from 'classnames';
import { ChevronDown } from 'lucide-react';
import { Icon } from '@/components/Icon';
import type { FullWidthProps, SharedComponentProps } from '../types';
import * as styles from './index.css';

type SelectProps = SharedComponentProps<'select'> &
    FullWidthProps & {
        selectRef?: React.Ref<HTMLSelectElement>;
    };

export function Select({ selectRef, children, fullWidth, className, ...props }: SelectProps) {
    return (
        <div className={classNames(styles.wrapper, { [styles.fullWidth]: fullWidth }, className)}>
            <select ref={selectRef} className={styles.select} {...props}>
                {children}
            </select>
            <span className={styles.caret}>
                <Icon icon={ChevronDown} size="sm" />
            </span>
        </div>
    );
}
